export default __webpack_public_path__ + "static/banner-home-renovation-loan-tips-a61d0a49dcc9ef8a43d08648c3d63079.jpg";